const $win = $(window);
const $doc = $(document);

const $winHeight = $win.height();
const deviate = 20;

const $targetElement = $('.product__form');
const $startElement = $('.product-holder > .product__tabs .tabs');
const $endElement = $('.footer');

function setClass() {
	if ($targetElement.length == 0) {
		return;
	}

	let targetElementHeight = $targetElement.find('.product__form-inner').height() + 70;
	let startElementPosition = $startElement.offset().top - 20;
	let endElementPosition = $endElement.offset().top;

	let winScrollTop = $win.scrollTop();

	if (winScrollTop > startElementPosition && targetElementHeight + winScrollTop < endElementPosition) {
		$targetElement.addClass('fixed').removeClass('absolute');
	} else if (targetElementHeight + winScrollTop > endElementPosition) {
		$targetElement.addClass('absolute').removeClass('fixed');
	} else {
		$targetElement.removeClass('fixed absolute');
	}
}

$doc.ready(function() {
	setClass();
});

$win.on('load', function() {
	setClass();
});

$win.on('scroll', function() {
	setClass();
});



// WEBPACK FOOTER //
// ./../src/assets/js/product-sticky-form.js